import {
  FETCH_INDUSTRY,
  FETCH_INDUSTRY_SUCCESS,
  FETCH_INDUSTRY_ERROR,
  ADD_INDUSTRY,
  ADD_INDUSTRY_SUCCESS,
  ADD_INDUSTRY_ERROR,
  UPDATE_INDUSTRY,
  UPDATE_INDUSTRY_SUCCESS,
  UPDATE_INDUSTRY_ERROR,
  RESET_UPDATE_INDUSTRY,
} from "constants/ActionTypes";

export const fetchIndustry = () => {
  return {
    type: FETCH_INDUSTRY,
  }
};

export const fetchIndustrySuccess = (industryList) => {
  return {
    type: FETCH_INDUSTRY_SUCCESS,
    payload: industryList,
  }
};

export const fetchIndustryError = (error) => {
  return {
    type: FETCH_INDUSTRY_ERROR,
    payload: error
  }
};


export const addIndustry = (payload) => {
  return {
    type: ADD_INDUSTRY,
    payload,
  }
};

export const addIndustrySuccess = (payload) => {
  return {
    type: ADD_INDUSTRY_SUCCESS,
    payload,
  }
};

export const addIndustryError = (error) => {
  return {
    type: ADD_INDUSTRY_ERROR,
    payload: error
  }
};

export const updateIndustry = (params) => {
  return {
    type: UPDATE_INDUSTRY,
    params,
  }
};

export const updateIndustrySuccess = (payload) => {
  return {
    type: UPDATE_INDUSTRY_SUCCESS,
    payload,
  }
};

export const updateIndustryError = (error) => {
  return {
    type: UPDATE_INDUSTRY_ERROR,
    payload: error
  }
};

export const resetAddIndustry = () => {
  return {
    type: RESET_UPDATE_INDUSTRY,
  }
};
